import { ListViewBitFlagsMasks, setBit } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { updateUserConfiguration } from 'owa-options-core';
import OwaViewStateConfiguration from 'owa-service/lib/contract/OwaViewStateConfiguration';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action, select } from 'satcheljs/lib/legacy';

export interface SetFolderPaneCollapsedState {
    viewStateConfiguration: OwaViewStateConfiguration;
}

/**
 * Persist the folder pane collapsed state
 * @param state the SetFolderPaneCollapsedState which contains user options
 */
export default action('setFolderPaneCollapsedState')(
    select({
        viewStateConfiguration: () => getUserConfiguration().ViewStateConfiguration,
    })(function setFolderPaneCollapsedState(
        isCollapsed: boolean,
        state?: SetFolderPaneCollapsedState
    ) {
        setBit(isCollapsed /* value */, ListViewBitFlagsMasks.FolderPaneCollapsed);
        updateUserConfiguration(
            [
                {
                    propertyName: 'ListViewBitFlags',
                    propertyType: 'Integer32',
                    propertyValue: `${state.viewStateConfiguration.ListViewBitFlags}`,
                },
            ],
            'OWA.ViewStateConfiguration'
        );
    })
);
